import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20e65a7e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=20e65a7e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e65a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e65a7e')) {
      api.createRecord('20e65a7e', component.options)
    } else {
      api.reload('20e65a7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=20e65a7e&scoped=true", function () {
      api.rerender('20e65a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/allocationOptions/index.vue"
export default component.exports